<template>
  <div class="car-record">
    <div class="title">今日在园车辆详情</div>
    <div style="width: 100%; height: 400px; overflow-y: auto;">
      <el-table :data="tableData" stripe>
        <el-table-column label="序号" type="index" width="70" align="center"></el-table-column>
        <el-table-column prop="enterCarNum" label="车牌号码" align="center"></el-table-column>
        <el-table-column prop="ownerName" label="车主姓名" align="center"></el-table-column>
        <el-table-column prop="enterTime" label="入场时间" align="center"></el-table-column>
        <el-table-column prop="parkingLot" label="停车场名称" align="center"></el-table-column>
        <el-table-column prop="deptName" label="用户部门" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { api } from "../api/index";
export default {
  data() {
    return {
      tableData: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getToday() {
      var day = new Date();
      day.setTime(day.getTime());
      var today = day.getFullYear() + "-" + ((day.getMonth() + 1) < 10 ? '0'+ (day.getMonth() + 1) : (day.getMonth() + 1)) + "-" + (day.getDate() < 10 ? '0'+ day.getDate() : day.getDate()) + " " + "00:00:00";
      return today
    },
    getYesterday() {
      var day = new Date();
      day.setTime(day.getTime() + 24 * 60 * 60 * 1000);
      var yesterday = day.getFullYear() + "-" + ((day.getMonth() + 1) < 10 ? '0'+ (day.getMonth() + 1) : (day.getMonth() + 1)) + "-" + (day.getDate() < 10 ? '0'+ day.getDate() : day.getDate()) + " " + "00:00:00";
      return yesterday
    },
    getList() {
      const params = {
        "pageNum": 1,
        "pageSize": 10000,
        "carStatus": "0",
        "enterTimeStrLeft": this.getToday(),
        "enterTimeStrRight": this.getYesterday()
      }
      this.$fetch(api.record.record, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj.list
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.car-record {
  padding: 20px;

  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
</style>